import { noteFiatHold } from "./fiatHoldStore";

export const FIAT_ERROR_COPY = {
  KYC_REQUIRED: "Complete identity verification before using fiat.",
  KYC_PROFILE_INCOMPLETE: "Your KYC profile is missing details required for a bank account.",
  USER_NOT_FOUND: "Account not found. Please sign in again.",
  VA_NOT_FOUND: "No virtual account yet.",
  VA_REQUIRED: "Create a virtual account before depositing.",
  FIAT_SERVICE_HELD: "Fiat is temporarily paused. New converts and withdrawals are unavailable.",
  ZAND_UNAVAILABLE: "Bank service is unavailable. Please try again later.",
  QUOTE_EXPIRED: "This quote expired. Request a new price.",
  QUOTE_UNAVAILABLE: "Live price is unavailable. Try again in a moment.",
  PRICE_MOVED: "The price moved. Request a new quote.",
  INVENTORY_LOW: "This buy cannot be filled right now. Your AED is unchanged.",
  FEE_WALLET_NOT_CONFIGURED: "Convert fees are not configured. Try again later.",
  INSUFFICIENT_BALANCE: "Not enough balance. Add funds or reduce the amount.",
  TREASURY_LOW: "Withdrawals are paused while liquidity is low.",
  CONVERT_ASSET_DISABLED: "This pair is not available.",
  AMOUNT_BELOW_MIN: "Amount is below the minimum.",
  FEE_SCHEDULE_MISSING: "Withdrawals unavailable",
  AMOUNT_ABOVE_MAX: "Amount is above the maximum.",
  LIMIT_EXCEEDED: "This would exceed your limit.",
  BENEFICIARY_NOT_VERIFIED: "Verify the bank account before withdrawing.",
  BENEFICIARY_NOT_FOUND: "That bank account is no longer available.",
  BENEFICIARY_IN_USE: "This bank account cannot be removed while a withdrawal is in progress.",
  WHITELIST_NOT_VERIFIED: "Verify the bank account before withdrawing.",
  WHITELIST_NOT_FOUND: "That bank account is no longer available.",
  WHITELIST_IN_USE: "This bank account cannot be removed while a withdrawal is in progress.",
  INVALID_IBAN: "Enter a valid UAE IBAN.",
  DUPLICATE_BENEFICIARY: "This bank account is already saved.",
  DUPLICATE_WHITELIST: "This bank account is already saved.",
  OTP_INVALID: "That code is incorrect or has expired.",
  OTP_LOCKED: "Too many attempts. Remove the account and add it again.",
  OTP_CHANNEL_UNAVAILABLE: "A verified email is required to confirm a bank account.",
  PAYOUT_SOURCE_UNAVAILABLE: "Payouts are unavailable right now. Try again later.",
  RATE_LIMITED: "Please wait before requesting another code.",
  NO_VERIFICATION_METHOD: "Add a security method before withdrawing.",
  EMAIL_OTP_INVALID: "That email code is incorrect.",
  MOBILE_OTP_INVALID: "That SMS code is incorrect.",
  GOOGLE_AUTH_INVALID: "That authenticator code is incorrect.",
  FUND_PASSWORD_INVALID: "That fund password is incorrect.",
  OTP_EXPIRED: "That code expired. Request a new one.",
  OTP_NOT_FOUND: "Request a new verification code, then try again.",
  WITHDRAWAL_NOT_FOUND: "Withdrawal not found.",
  INVALID_STATE: "This withdrawal can no longer be cancelled.",
  INTENT_NOT_FOUND: "Deposit instructions not found.",
  DEPOSIT_NOT_FOUND: "Deposit not found.",
  QUOTE_NOT_FOUND: "Quote not found.",
  QUOTE_ALREADY_EXECUTED: "This quote was already converted.",
  VALIDATION_ERROR: "Please check the form and try again.",
};

export function mapFiatError(res) {
  if (!res || res.success) return null;
  const code = res.code || "FIAT_ERROR";
  const err = {
    code,
    message: FIAT_ERROR_COPY[code] || res.message || "Request failed",
    data: res.data || null,
  };
  noteFiatHold(err);
  return err;
}

export function isFiatHeldError(err) {
  return err?.code === "FIAT_SERVICE_HELD";
}
